import { createContext } from "react";

const TenantContext = createContext({
  tenant: {},
  setTenant: value => {},
});

export default TenantContext;